var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.current)?_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"mt-5",attrs:{"cols":"10","md":"5"}},[_c('markdown-component',{staticClass:"mt-4",attrs:{"source":_vm.current.text}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }